import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelRegularMedium,
    CustomLabelSmallBold, CustomLabelXSmallRegular
} from "../common/CustomLabel";
import Slider from "react-slick/lib";
import Paper from "@mui/material/Paper/Paper";
import Box from "@mui/material/Box/Box";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
import React from "react";
// import FITNESS_CLOTHING2 from "../../assets/images/FitnessClothing(2).jpg";
import FITNESS_CLOTHING from "../../assets/images/FitnessClothing.png";
// import PAF2 from "../../assets/images/PAF(2).jpg";
// import PAF from "../../assets/images/PAF.jpg";
// import SIPSKIP2 from "../../assets/images/SipSkip(2).jpg";
import SIPSKIP from "../../assets/images/SipSkip.png";
// import THE_CHECKER_APP2 from "../../assets/images/TheCrackApp(2).jpg";
import THE_CHECKER_APP from "../../assets/images/TheCrackApp.png";
import DUBAI_AIRPORT from "../../assets/images/DubaiAirport.png";
import EL_PADEL from "../../assets/images/ElPadel.png";
// import NUNCMITTO from "../../assets/images/Nuncmitto.png";
import NUNCMITTO from "../../assets/images/Nuncmitto.webp";


// import {
    // useLocation, Outlet, 
    // useNavigate} from "react-router-dom"

const truncateByWords = (text, maxWords = 60) => {
    const words = text.split(' ');
    if (words.length > maxWords) {
        return words.slice(0, maxWords).join(' ') + '...';
    }
    return text;
};

const workData = [
    {
        image: FITNESS_CLOTHING,
        title: "BabezLondon Website Revamp",
        description: "BabezLondon, a fashion and beauty e-commerce platform, partnered with OSTRYX to revamp its website, enhance user experience, and develop a robust admin panel for business insights. The project included a modern website redesign, a powerful dashboard for order and inventory management, and long-term maintenance with dedicated developer support to ensure scalability and smooth operations.",
        tags: ["React.js", "Node.js", "PostgreSQL"]
    },
    {
        image: THE_CHECKER_APP,
        title: "The Checker App",
        description: "The Checker App is a hotel cleaning and management system built for a cleaning company to improve efficiency. OSTRYX developed an iPad app and web-based admin panel with multiple user roles, allowing real-time task management, quality checks, and front-desk coordination. The system includes a strong backend, a well-designed app for hotel staff, and ongoing maintenance to keep it running smoothly.",
        tags: ["React.js", "Node.js", "Flutter", "PostgreSQL"]
    },
    {
        image: SIPSKIP,
        title: "SipSkip",
        description: "Sipskip is a platform designed to promote recycling through a website and mobile app. OSTRYX developed a WordPress-based website for user engagement and a Flutter mobile app to help users locate recycling points and track their activities. The system includes a recycling locator, reward system, and user dashboard, backed by a strong Node.js backend. Ongoing maintenance ensures reliable performance and feature updates.",
        tags: ["WordPress", "Node.js", "Flutter", "PostgreSQL"]
    },
    {
        image: DUBAI_AIRPORT,
        title: "Dubai International Airport Firefighter Simulation OS",
        description: "OSTRYX developed a custom Firefighter Simulation Operating System for Dubai International Airport to improve training and operations. Built with Electron.js and integrated with Google Maps APIs, the system provides real-world location simulation for enhanced training. The project included full-cycle development, from concept to deployment, with ongoing maintenance for reliability and performance.",
        tags: ["Electron.js", "Google Maps APIs"]
    },
    {
        image: EL_PADEL,
        title: "El padel",
        description: "El Padel, a leading e-commerce platform, partnered with OSTRYX for dedicated website maintenance to ensure smooth performance, security updates, and long-term reliability. Our team provides continuous support to enhance functionality, fix bugs, and optimize performance, keeping the platform secure and competitive.",
        tags: []
    },
    {
        image: NUNCMITTO,
        title: "Nuncmitto Digital Food App",
        description: "OSTRYX developed Nuncmitto, a US-based digital food platform that enables users to purchase and share digital food gifts, redeemable at partner restaurants. The platform includes a mobile app for customers, a restaurant portal, a super admin panel, and a dedicated support panel for seamless management.",
        tags: ["React.js", "Node.js", "React Native"]
    }
    // ... add other work items
];

const SeeOurWork = ({portfolioRef, settings_our_work}) => {

    // let navigate = useNavigate();


    // const onClickService = () => {
    //     navigate('/service-details')
    // }

    return (
        <Grid container sx={{paddingBottom: {xs: "0px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>

            <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                <CustomLabelMediumBold text={"SEE OUR WORK"} fontWeight={700} color={"#5E17EB"}/>
            </Grid>
            <div ref={portfolioRef} tabIndex={0}></div>

            <Grid item container xs={10} md={10} style={{marginTop: "5px"}} justifyContent={"center"} alignItems={"center"}>
                <CustomLabelMediumRegular normal={false}
                                          textAlign={"center"}
                                          text={"Shaping the future across multiple sectors with innovative solutions and strategic expertise!"}
                />
            </Grid>


            <Grid item xs={12} sx={{padding: {xs: "0px 5px", md: "0px 30px"}, marginTop: "40px", textAlign: "justify"}}>
                <div className="slider-container">
                    <Slider {...settings_our_work}>
                        {workData.map((work, index) => (
                            <div key={index}>
                                <Paper
                                    // onClick={onClickService}
                                    sx={{
                                        width: "100%",
                                        marginBottom: "10px",
                                        background: "#FAF7FF",
                                        borderRadius: "25px",
                                        height: { xs: '360px', md: '500px', lg: '600px' },
                                        display: 'flex',
                                        '& .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                            transition: 'color 0.3s ease-in-out',
                                        },
                                        '&:hover .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                            color: '#5E17EB',
                                        },
                                        '& .css-2fjh4h': {
                                            // filter: 'grayscale(100%)',
                                            transition: 'filter 1.5s ease-in-out, transform 1s ease-in-out',
                                        },
                                        '&:hover .css-2fjh4h': {
                                            filter: 'grayscale(0%)',
                                            transform: 'scale(1.1)',
                                            transition: 'filter 1.5s ease-in-out, transform 1s ease-in-out',
                                        }
                                    }}>
                                    <Grid item container direction="column"
                                          sx={{
                                              padding: {xs: "5px", md: "10px"},
                                              height: '100%'
                                          }}>
                                        <Grid item>
                                            <Box 
                                                sx={{
                                                    width: "100%",
                                                    height: {xs: "188px", md: "282px", lg: "320px"},
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    position: "relative"
                                                }}
                                            >
                                                <Box 
                                                    component={"img"} 
                                                    src={work.image} 
                                                    alt={work.title}
                                                    sx={{
                                                        width: "100%",
                                                        height: "100%",
                                                        borderRadius: "10px",
                                                        objectFit: "cover",
                                                        transition: "transform 0.3s ease-in-out",
                                                        "&:hover": {
                                                            transform: "scale(1.1)"
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item sx={{padding: {xs: "10px 10px", md: "12px 16px"}}}>
                                            <CustomLabelSmallBold 
                                                text={work.title}
                                                fontWeight={700}
                                            />
                                        </Grid>
                                        <Grid item
                                              sx={{padding: {xs: "0px 10px", md: "0px 16px"}, flex: 1}}>
                                            <CustomLabelRegularMedium
                                                text={truncateByWords(work.description, 20)}
                                                color={"#333333"}
                                                normal={true}
                                                fontWeight={400}
                                                textAlign={"left"}
                                            />
                                        </Grid>
                                        <Grid item container justifyContent="space-between"
                                              sx={{padding: {xs: "10px", md: "16px"}, mt: 'auto'}}>
                                            {work.tags.map((tag, tagIndex) => (
                                                <Grid item key={tagIndex} sx={{
                                                    background: "white",
                                                    padding: {xs: "5px", md: "10px"},
                                                    borderRadius: 16,
                                                }}>
                                                    <CustomLabelXSmallRegular text={tag}/>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        ))}
                    </Slider>
                </div>
            </Grid>


        </Grid>
    )
}


export default SeeOurWork;
